import { styledComponent, Grid, Typography, Paper, Divider } from '@hermes/web-components'

export const StyledDivider = styledComponent(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.background.searchCardPaper,
  minWidth: '100%'
}))

export const StyledNumber = styledComponent(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  [theme.breakpoints.down('lg')]: {
    ...theme.typography.h2,
    fontSize: theme.typography.h2.fontSize
  },
  marginRight: 4,
  fontFamily: 'Poppins',
  lineHeight: '20px',
  color: theme.palette.text.darkNavy
}))

export const StyledNumberSearch = styledComponent(StyledNumber)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    ...theme.typography.h2,
    fontFamily: 'Poppins',
    fontSize: '13px'
  }
}))

export const StyledNumberDescription = styledComponent(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  whiteSpace: 'pre-line',
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.text.darkNavy
}))

export const StyledPaper = styledComponent(Paper, {
  shouldForwardProp: (prop: string) => !['isProfileReviewsPresent', 'isUnclaimed'].includes(prop)
})<{ isProfileReviewsPresent?: boolean }>(({ isProfileReviewsPresent, theme }) => ({
  width: '100%',
  borderRadius: 0,
  cursor: isProfileReviewsPresent ? 'pointer' : 'auto',
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  backgroundColor: 'transparent',
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.background.searchCardPaper}`,
  [theme.breakpoints.down('lg')]: {
    borderBottom: 'none',
    borderTop: `1px solid ${theme.palette.background.searchCardPaper}`,
    paddingTop: '16px',
    paddingBottom: 0
  }
}))

export const RatePaperMobileTypography = styledComponent(Typography)(({ theme }) => ({
  ...theme.custom.SearchProfileCard.mobile.subtitleText,
  width: '90%',
  lineHeight: '20px'
}))

export const StyledGridForPaper = styledComponent(Grid)(({ theme }) => ({
  padding: '47px 16px',
  borderLeft: `1px solid ${theme.palette.background.searchCardPaper}`,
  height: '100%',
  [theme.breakpoints.down('lg')]: {
    padding: '0 20px',
    borderLeft: 'none'
  }
}))

export const SearchCardsDivider = styledComponent(Divider)(({ theme }) => ({
  width: '100%',
  height: '4px',
  border: 'none',
  backgroundColor: theme.palette.grey[100],
  [theme.breakpoints.up('lg')]: {
    display: 'none'
  }
}))
